import React, { Fragment, useEffect, useState } from 'react';

import { List, ListItem, ListItemIcon, Divider, Box, Typography, ListSubheader } from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { AccountCircle, AssignmentLate, Business, Description, ExitToApp, Folder } from '@material-ui/icons';
import { useHistory, useLocation } from 'react-router';
import { useAuth0 } from '@auth0/auth0-react';

import { DrawerWrapper } from 'src/components';
import { urlJoin } from 'src/utils/util';


const drawerWidth = 97;

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: theme.zIndex.drawer,
  },
  drawerPaper: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    paddingTop: theme.spacing(9),
    overflowX: 'hidden',
    width: drawerWidth,
    backgroundColor: theme.palette.common.gray800,
    color: theme.palette.common.white,
  },
  sectionHeader: {
    lineHeight: 0,
    color: theme.palette.common.white,
  },
  listItem: {
    padding: theme.spacing(2),
  },
  listItemSelected: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    color: theme.palette.common.white,
  },
  list: {
    height: '100%',
  },
  itemText: {
    whiteSpace: 'normal',
    wordWrap: 'normal',
    textAlign: 'center',
    lineHeight: 1.2,
  },
  listItemDisabled: {
    opacity: 0.5,
  },
}));

const handleLogout = async logout => {
  logout({ logoutParams: window.location.origin });
  localStorage.clear();
};

const mainActions = [
  {
    Icon: Business,
    label: 'Corporación',
    endPath: 'company-summary',
  },
  {
    Icon: Folder,
    label: 'Proyectos',
    endPath: 'projects',
    subEndPaths: [ 'land', 'freshwater', 'biodiversity' ],
  },
  // {
  //   Icon: TrackChanges,
  //   label: 'Impactos y Dependencias',
  //   endPath: 'pressures-and-dependencies',
  // },
  {
    Icon: AssignmentLate,
    label: 'Riesgos',
    endPath: 'company-summary',
    isDisabled: true,
  },
  {
    Icon: Description,
    label: 'Reportes',
    endPath: 'company-summary',
    isDisabled: true,
  },
  // {
  //   Icon: Business,
  //   label: 'Corporación',
  //   endPath: 'company-summary',
  // },
  // {
  //   Icon: MapSearch,
  //   label: 'Planes de monitoreo',
  //   endPath: 'monitoring-plans',
  // },
  {
    Icon: AccountCircle,
    label: 'Cuenta',
    endPath: 'profile',
    pushToBottom: true,
  },
  {
    Icon: ExitToApp,
    label: 'Cerrar sesión',
    endPath: 'logout',
    actionFn: handleLogout,
  },
];

const getEndPath = currentPath => {
  const regex = /\/([^/]+)\/?$/;
  const match = currentPath.match(regex);
  return match ? match[1] : '';
};

const MainDrawer = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { logout } = useAuth0();

  const [ selectedIndex, setSelectedIndex ] = useState(0);

  const endPath = getEndPath(location.pathname);
  useEffect(() => {
    const currentIndex = mainActions.findIndex(item => item.endPath === endPath || item.subEndPaths?.includes(endPath));
    if (currentIndex !== -1) {
      setSelectedIndex(currentIndex);
    }
  }, [ endPath ]);

  const baseUrl = '/web';
  const handleListItemClick = (index, path) => history.push(urlJoin(baseUrl, path));

  return (
    <DrawerWrapper className={classes.drawer} variant="permanent" classes={{ paper: classes.drawerPaper }} width={drawerWidth}>
      <List className={classes.list}>
        <Box height="100%" display="flex" flexDirection="column">

          {mainActions.map(({ Icon, label, endPath, sectionName, actionFn, pushToBottom, isDisabled }, itemIndex) => (
            <Fragment key={itemIndex}>
              {sectionName &&
              <>
                <Box {...(itemIndex === 0 ? { pb: 2 } : { py: 2 })} mx={-1}>
                  <Divider />
                </Box>
                <Box py={2}>
                  <ListSubheader className={classes.sectionHeader} color="primary">
                    {sectionName}
                  </ListSubheader>
                </Box>
              </>
              }
              {pushToBottom && <Box flexGrow={1} />}
              <ListItem
                className={`${classes.listItem} ${isDisabled ? classes.listItemDisabled : ''}`}
                classes={{ selected: classes.listItemSelected }}
                button={!isDisabled}
                disabled={isDisabled}
                onClick={() => !isDisabled && (actionFn ? actionFn(logout) : handleListItemClick(itemIndex, endPath))}
                selected={selectedIndex === itemIndex && !isDisabled}
              >
                <ListItemIcon>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    color="white"
                    width="64px"
                    height="64px"
                  >
                    <Icon />
                    <Typography variant="body2" className={classes.itemText}>{label}</Typography>
                  </Box>
                </ListItemIcon>
              </ListItem>
            </Fragment>
          ))}
        </Box>
      </List>
    </DrawerWrapper>
  );
};

MainDrawer.propTypes = {
  name: PropTypes.string,
};


export { MainDrawer };